import React from 'react'
import { LPInvestment } from '../../../types'
import { A } from '../../atoms/A'
import { Table, TableCell, TableHeading, SubLabel } from '../../atoms/Table'
import { formatWithComma } from '@/lib/number'
import { EmptyCard } from '../../common/EmptyCard'
import { Help } from '../../common/Help'
import { FormattedDate } from '../../atoms/FormattedDate'

type Props = {
  list: LPInvestment[]
  shortname: string
  className?: string
}

export const LPInvestmentTable: React.FC<Props> = (props) => {
  if (props.list.length === 0) {
    return <EmptyCard />
  }

  return (
    <Table>
      <thead>
        <tr>
          <TableHeading>ファンド出資者明細</TableHeading>
          <TableHeading>ファンド</TableHeading>
          <TableHeading>
            開始日
            <Help>取扱開始日、設立日、組成予定年月、（日は月末とする）</Help>
          </TableHeading>
          <TableHeading>
            ファンド額
            <SubLabel>百万円</SubLabel>
            <Help>出資総額</Help>
          </TableHeading>
          <TableHeading sub="百万円">出資金額</TableHeading>
          <TableHeading>ファンド種別</TableHeading>
          <TableHeading>
            ファンド類型
            <Help>
              地域密着型、汎用型、業種特化型、産学連携型、シードアクセラレーター等
            </Help>
          </TableHeading>
          <TableHeading>
            重点ステージ
            <Help>{`シード・アーリー・エクスパンション・レータ\n・バランス型・バイアウト型・再生企業`}</Help>
          </TableHeading>
          <TableHeading>
            重点業種
            <Help>{`ＩＴ関連・バイオ医療ヘルスケア(エネルギーを除く)\n・エネルギー関連・製品サービス`}</Help>
          </TableHeading>
        </tr>
      </thead>
      <tbody>
        {props.list.map((detail, i) => (
          <tr key={i}>
            <TableCell>
              <A decoration="none" href={detail.path}>
                {detail.shortname}
              </A>
            </TableCell>
            <TableCell>
              <A
                href={`/investors/${props.shortname}/funds/${detail.fund.shortname}`}
                decoration="none"
              >
                {detail.fund.name}
              </A>
            </TableCell>
            <TableCell nowrap>
              <FormattedDate>{detail.established}</FormattedDate>
            </TableCell>
            <TableCell align="right">
              {detail.amount && formatWithComma(detail.amount)}
            </TableCell>
            <TableCell>
              {detail.investment &&
                formatWithComma(detail.investment, { decimalPlace: 1 })}
            </TableCell>
            <TableCell>{detail.classification}</TableCell>
            <TableCell>{detail.type}</TableCell>
            <TableCell>{detail.stages.join(', ')}</TableCell>
            <TableCell>{detail.industries.join(', ')}</TableCell>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}
